(function () {
  var STORAGE_KEY = 'wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { count: list.length } })
    );
  }

  function isInWishlist(productId) {
    return getWishlist().some(function (item) {
      return String(item.id) === String(productId);
    });
  }

  function addToWishlist(product) {
    var list = getWishlist();
    if (!isInWishlist(product.id)) {
      list.push(product);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(productId) {
    var list = getWishlist().filter(function (item) {
      return String(item.id) !== String(productId);
    });
    saveWishlist(list);
  }

  function toggleWishlist(product) {
    if (isInWishlist(product.id)) {
      removeFromWishlist(product.id);
      return false; // now removed
    } else {
      addToWishlist(product);
      return true; // now added
    }
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      if (el.textContent !== String(count)) {
        el.textContent = count;
      }
    });
  }

  document.addEventListener('wishlist:updated', updateCountBadges);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCountBadges);
  } else {
    updateCountBadges();
  }

  window.addEventListener('load', updateCountBadges);

  // Some themes re-render header/drawer markup dynamically (cart updates,
  // section re-renders, sticky header clones, etc). Watch for any DOM
  // changes and re-apply the badge value whenever that happens.
  var wishlistObserver = new MutationObserver(function () {
    updateCountBadges();
  });
  wishlistObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.Wishlist = {
    get: getWishlist,
    isInWishlist: isInWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist
  };
})();